import LoadingContentWrapper from './LoadingContentWrapper';
import LoadingSpinner from '@/components/LoadingSpinner';
import Space from '@/components/Space';
import React from 'react';
import { type HTMLSectionProps } from '@/lib/types';

type LoadingSpinnerWithTextProps = HTMLSectionProps & {
  noPadding?: boolean;
  children: React.ReactNode;
};

// TODO use `p` instead of H3
const LoadingSpinnerWithText = ({
  noPadding,
  children,
  ...props
}: LoadingSpinnerWithTextProps) => (
  <LoadingContentWrapper noPadding={!!noPadding} {...props}>
    <LoadingSpinner color="primary" />
    <Space width={18} />
    <h3>{children}</h3>
  </LoadingContentWrapper>
);

export default LoadingSpinnerWithText;
